/// <amd-module name="VSSUI/Utilities/Image" />

import * as React from "react";

export const openImageInNewTab = (event: React.MouseEvent<HTMLDivElement>): void => {
    const clickedElement = event.target;
    if (clickedElement instanceof HTMLImageElement) {

        const imageUrl = clickedElement.src;
        
        if (!imageUrl || isIdentityImage(clickedElement)) {
            return;
        }

        openLinkInSeparateWindow(imageUrl);

        event.preventDefault();
        event.stopPropagation();
    }
};

const isIdentityImage = (element: HTMLElement): boolean => {
    return !!element.parentElement?.classList.contains("bolt-identity-card-persona-main");
};

const openLinkInSeparateWindow = (link: string): void => {
    const openedWindow = window.open(link, "_blank");

    if (openedWindow) {
        // Ensure no hijacking is possible.
        openedWindow.opener = null;
    }
};